import { DotLegalFile } from "@dotlegal/dotlegal-ui-components";

// Edit dialogs seed their upload model with an empty file so the model counts as valid without a new upload.
// The upload component rejects empty files, so an empty file is always that placeholder and is never sent.
export function createPlaceholderFile(): DotLegalFile {
    return { fileName: "", file: new File([], "") };
}

export function getFileToUpload(files: Array<DotLegalFile> | undefined): File | undefined {
    const file = files?.[0]?.file;
    return file && file.size > 0 ? file : undefined;
}
